
import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useAuthStore, useCarritoClienteStore, useGlobalValueStore, useProductosStore } from "../../../stores";
import { useListCarritoXUser, useProductosXCategoria, useProductosXID } from "../../../hooks/cache";
import { LayoutCrearDoc } from "../../layouts";
import { Box, Grid, Typography } from "@mui/material";
import { AutocompleteNombre, CargandoMedio } from "../../components";
import { FormularioCantidadColor, FormularioCantidadx10, FormularioCantidadx50, FormularioCorteVinilo, FormularioEstructuras, FormularioLitografia, FormularioPrendas, FormularioSoloCantidad } from "../../productos/formularios";
import { cantidadColor, cantidax10, cantidax50, corteVinilo, estructurasEcosolvente, litografia, nombreSoloCantidad, prendas } from "../../../data";
import { agregarItemCarritoAdmin, productosXID } from "../../../services";
import { generarIDGenerico } from "../../../helpers/operacionesStrings";


import Swal from "sweetalert2";



const baseUrl = process.env.REACT_APP_API_URL;
const createInitialValues = (prod, usuarioId) => ({
    producto: prod,
    usuario: usuarioId,
    cantidad: '',
    color: '',
    talla: '',
    genero: '',
    disenio: '',
    unidadMedida: '',
    alto: '',
    ancho: '',
    terminados: '',
    totalCliente: '',
    totalDistri: '',
    totalEmpresa: '',
    totalPublicista: '',
});




export const DetalleProductoCliente = () => {

    const { cat, prod } = useParams();
    const queryClient = useQueryClient();

    const { cliente } = useAuthStore();
    const { view } = useGlobalValueStore();
    const titulo = (view) ? `Venta realizada a ${view}` : 'Por favor seleccione tipo de cliente';
    const { items, agregarItem } = useCarritoClienteStore();
    const [formCarrito, setFormCarrito] = useState( createInitialValues(prod, cliente?.id) );
    const { data, isLoading } = useProductosXCategoria(cat);
    const { setActivarTerminado, activarProductoupdate, setActivarProdUpdate } = useProductosStore();

    const { data:carritos } = useListCarritoXUser(cliente?.id);
    const itemsClienteCarrito = (cliente) ? carritos : items;
    const { data:produc } = useProductosXID(formCarrito.producto);


    const handleInputProducto = (newValor) => {
        setFormCarrito({ ...formCarrito, producto:(newValor) ? newValor.id : null });
    }


    const handleAgregarAlCarro = async( itemExistente=null ) => {
        // const validarItem = itemExistente || activarProductoupdate?.id;
        const validarItem = null;

        if( cliente ){
            const resp = await agregarItemCarritoAdmin(formCarrito, validarItem);
            if( resp ){ 
                setFormCarrito(createInitialValues(prod, cliente?.id));
                await queryClient.invalidateQueries({ queryKey: ['carritoxuser'] });
                setActivarTerminado(null);
            }
        }

        const producto = await queryClient.fetchQuery({
            queryKey: ['productoXid-cliente', formCarrito.producto],
            queryFn: () => productosXID(formCarrito.producto),
        });
        const datos = { 
            ...formCarrito,
            id: generarIDGenerico(), 
            producto: {
                _id: producto.id,
                img: producto.img,
                nombre: producto.nombre,
                precioDistri: producto.precioDistri,
                precioEmpresa: producto.precioEmpresa,
                precioPublicista: producto.precioPublicista,
                precioVenta: producto.precioVenta,
        }}
        Swal.fire('Exitoso', 'Item Agregado', 'success')
        agregarItem(datos);
        setFormCarrito(createInitialValues(prod, cliente?.id));
        // if( activarProductoupdate ){
        //     return navigate(`/super/comprar-ahora`);
        // }
    }



    useEffect(() => {
        if(activarProductoupdate) {
            const { producto, terminados, ...resto } = activarProductoupdate;
            setFormCarrito({ ...formCarrito, terminados: (terminados) ? terminados._id : '', ...resto })
        }
        return () => { setActivarProdUpdate(null) }
    }, [activarProductoupdate]);




    return (

        <LayoutCrearDoc titulo='Detalles de Producto' subtitulo={titulo} add={false} pt={4} px={5} pb={2}>
            {(produc) 
            ?   <Grid container sx={{mt:5}}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={5}>
                            <img src={ `${baseUrl}/uploads/productos/${ produc?.img }`} style={{width:'100%'}} />
                        </Grid>

                        <Grid item xs={12} sm={7}>
                            <Typography variant="h4" sx={{fontSize:'22px', mt:-1}}>Seven For Ever S.A.S.</Typography>
                            <Typography variant="body">{ produc.nombre }</Typography>

                            <Grid item xs={12} sx={{mt:1}}>
                                <AutocompleteNombre
                                    size="small"
                                    name="producto"
                                    value={ formCarrito.producto }
                                    onChange={ handleInputProducto }
                                    options={isLoading ? [] : data}
                                />
                            </Grid>


                            {(prendas.includes(produc.categoria.nombre)) &&
                            <FormularioPrendas
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ itemsClienteCarrito }
                            />
                            }

                            {(nombreSoloCantidad.includes(produc.categoria.nombre)) &&
                            <FormularioSoloCantidad
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ itemsClienteCarrito }
                            />
                            }

                            {(cantidadColor.includes(produc.categoria.nombre)) &&
                            <FormularioCantidadColor 
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ itemsClienteCarrito }
                            />
                            }

                            {(litografia.includes(produc.categoria.nombre)) &&
                            <FormularioLitografia
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ itemsClienteCarrito }
                            />
                            }

                            {(estructurasEcosolvente.includes(produc.categoria.nombre)) &&
                            <FormularioEstructuras 
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ itemsClienteCarrito }
                            />
                            }

                            {(cantidax10.includes(produc.categoria.nombre)) &&
                            <FormularioCantidadx10 
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ itemsClienteCarrito }
                            />
                            }

                            {(cantidax50.includes(produc.categoria.nombre)) &&
                            <FormularioCantidadx50 
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ itemsClienteCarrito }
                            />
                            }

                            {(corteVinilo.includes(produc.categoria.nombre)) &&
                            <FormularioCorteVinilo 
                                formCarrito={formCarrito} 
                                setFormCarrito={setFormCarrito} 
                                funcionAgregar={handleAgregarAlCarro}
                                poducto={ produc }
                                carrito={ itemsClienteCarrito }
                            />
                            }
                        </Grid>
                    </Grid>


                    <Grid container sx={{mt:3, display:'flex', flexDirection:'column', mb:2}}>
                        <Typography variant="h2" gutterBottom>Uso del Producto</Typography>
                        <Typography variant="body" sx={{mt:-1}}>{ produc.uso }</Typography>
                    </Grid>


                    <Grid container sx={{mt:3, display:'flex', flexDirection:'column', mb:2}}>
                        <Typography variant="h2" gutterBottom>Recomendaciones</Typography>
                        <Typography variant="body" sx={{mt:-1}}>{ produc.recomendaciones }</Typography>
                    </Grid>

                </Grid>

            :   <CargandoMedio titulo="Cargando Producto..." />

            }
        </LayoutCrearDoc>
    )
}